module.exports = __webpack_public_path__ + "img/Villa_Borna_26.abf67779.jpg";